import React from 'react'
import { useTranslation } from 'react-i18next'
import InfoBlock from '@/routes/Quizzes/OldPortalComponents/InfoBlock'

const QuizImportInstructions: React.FC = () => {
  const { t } = useTranslation('translation')

  return (
    <InfoBlock>
      {t(
        'Upload a document that includes questions. We support multiple choice questions (MCQ) and open-ended text questions.',
      )}
    </InfoBlock>
  )
}

export default QuizImportInstructions
